import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import ErrorMessage from '../ErrorMessage';
import { InputProps } from '../Input';
import TopFieldContent from '../TopFieldContent';
import CharactersCount from '../CharactersCount/CharactersCount';
import useFormName from '../../../../../../Hooks/useFormName';
import TextArea from '../TextArea';
import InputWrapper from '../InputWrapper/InputWrapper';

interface Props extends InputProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	placeholder?: string;
	charactersLimit?: number;
	isWrapped?: boolean;
}

const TextAreaField = ({
	name,
	label,
	isRequired,
	className,
	placeholder,
	charactersLimit,
	isWrapped,
	...inputProps
}: Props) => {
	const { fieldName } = useFormName({ name });

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: '',
	});

	const component = (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<TextArea hasError={Boolean(error?.message)} {...inputProps} {...field} />
			{error?.message && <ErrorMessage tx={error.message} />}
			{charactersLimit && (
				<CharactersCount limit={charactersLimit} value={field.value} />
			)}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default TextAreaField;
